export const MAP_FLY_DURATION = 0.4;
